<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light bg-light">
            <div class="container">
                <router-link
                    class="navbar-brand"
                    :to="{ name: 'studies' }"
                >
                    <img
                        src="../assets/img/chiesi-logo.svg"
                        height="30"
                        class="d-inline-block align-top"
                    >
                </router-link>

                <div class="seperator mr-3 ml-1" />

                Study Dashboard

                <div class="ml-auto">
                    <ul class="navbar-nav mr-auto">
                        <li
                            v-if="isLoggedIn"
                            class="nav-item"
                        >
                            <router-link
                                :to="{ name: 'studies' }"
                                class="nav-link"
                            >
                                Studies
                            </router-link>
                        </li>

                        <li
                            v-if="isLoggedIn"
                            class="nav-item"
                        >
                            <router-link
                                :to="{ name: 'groups' }"
                                class="nav-link"
                            >
                                Groups
                            </router-link>
                        </li>

                        <li
                            v-if="isLoggedIn"
                            class="nav-item"
                        >
                            <a
                                class="nav-link clickable"
                                @click="signOut()"
                            >Sign Out</a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>

        <div class="background" />

        <div class="container px-0 pt-4 pb-4">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: 'Admin',

    computed: {
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
    },

    methods: {
        signOut() {
            localStorage.removeItem('accessToken');

            this.$store.state.accessToken = {};

            this.$router.push({
                name: 'login',
            });
        },
    },
};
</script>

<style scoped>
nav {
    background: #FFFFFF;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}

.seperator {
    height: 40px;
    background-color: #425563;
    width: 1px;
}

.clickable {
  cursor: pointer;
}
</style>
